const SvgVoxbox = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24">
    <path fill="#373737" fillRule="evenodd" d="M12 .914 22 7.04v9.99l-10 6.053-10-6.052V7.04zM3 7.6v8.262l8.5-5.145V2.393zm9.5-5.208v8.325l8.5 5.145V7.6zm8.034 14.357L12 11.584 3.466 16.75 12 21.916z" clipRule="evenodd" />
  </svg>;
export default SvgVoxbox;